import axios from "axios";
import config from "../config.js"
import File from "../models/File.js";

const FILES_API = config.API_URL + '/files';

export default {

  upload(fileList, clientId, origin) {
    const config = {headers: {'Content-Type': 'multipart/form-data'}};
    let fd = new FormData();
    Array.from(Array(fileList.length).keys()).map(index => {
      fd.append('files', fileList[index]);
    });
    let api = FILES_API + "/upload";
    if (clientId) {
      api += "/" + origin + "/" + clientId;
    }
    return axios
      .post(api, fd, config);
  },

  getFiles(origin, clientId) {
    let api = FILES_API + '/' + origin;
    if (clientId) {
      api += "/" + clientId;
    }
    return axios
      .get(api)
      .then(response => {
        return response.data.map(f => new File(f));
      });
  },

  downloadFile(fileId, clientId) {
    let api = FILES_API + "/download/" + fileId;
    if (clientId) {
      api += "/" + clientId;
    }
    //As FS is not available, we have to do the download thru this way
    return axios({
      method: 'get',
      url: api,
      responseType: 'blob' //Important
    })
      .then((response) => {
        let contentDisposition = response.request.getResponseHeader('Content-Disposition');
        let startFileNameIndex = contentDisposition.indexOf('"') + 1;
        let endFileNameIndex = contentDisposition.lastIndexOf('"');
        let filename = contentDisposition.substring(startFileNameIndex, endFileNameIndex);

        this.downloadBlob(response.data, filename, response.headers.contentType);
      });
  },

  downloadBlob(data, filename, mime) {
    let blob = new Blob([data], {type: mime || 'application/octet-stream'});
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // IE workaround for "HTML7007: One or more blob URLs were
      // revoked by closing the blob for which they were created.
      // These URLs will no longer resolve as the data backing
      // the URL has been freed."
      window.navigator.msSaveBlob(blob, filename);
    } else {
      let blobURL = window.URL.createObjectURL(blob);
      let tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename);

      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }

      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }
  },

  deleteFile(fileId, clientId) {
    let api = FILES_API + "/" + fileId;
    if (clientId) {
      api += "/" + clientId;
    }
    return axios.delete(api)
  },

  renameFile(file, clientId) {
    let api = FILES_API;
    if (clientId) {
      api += "/admin";
    }
    return axios.put(api, file)
  }
}



// WEBPACK FOOTER //
// ./src/services/fileService.js